import url from './../../config/url';
import axios from 'axios';
import state from './state';
import common from '../../static/js/common';

const actions = {
    /*
    *  获取购物车数量
    * */
    getCartNum() {
        axios.get(
            url.getCartNum,
            {
                params: {
                    userType: 1
                }
            }
        ).then(function (res) {
            if (res.data.result != null) {
                state.cartNum = res.data.result;
            }
        }).catch(function () {
            console.log('数据获取失败,请稍后再试!');
        });
    },
    /*
    *  获取用户信息
    * */
    getUserInfo(context, payload) {
        common.addCasIframe(function () {
            axios.get(
                url.getUserInfo
            ).then(function (res) {
                if (res.data.result != null) {
                    state.userInfo = res.data.result;
                    if (res.data.result.userId != null) {
                        context.userId = res.data.result.userId;
                        if (payload != null && (typeof payload == "function")) {
                            payload();
                        }
                    }
                }
            }).catch(function () {
                console.log('数据获取失败,请稍后再试!');
            });
        });
    },
    getDefaultCity(context, payload) {
        context.state.defaultCity = payload;
    },

};


export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js